import React from 'react';
import './Welcome.css';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Link as RouterLink } from 'react-router-dom';

const Welcome = (props) => {

    const monthArray = [
        "January", 
        "February",
        "March", 
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",        
    ]

    const today = new Date();
    const date = `${today.getDate()} ${monthArray[today.getMonth()]} ${today.getFullYear()}`;

    return (
        <div className="welcome">
            <Typography variant="caption" display="block" style={{marginBottom:20}}>Today is {date}</Typography>
            <Button variant="contained" color="primary" style={{marginBottom:20}} component={RouterLink} to="/calculator" >
            Calculate CrCl
            </Button>
            
            <Typography variant="body1">Who should use this calculator?</Typography>
            <Typography variant="body2" style={{marginBottom:20}}>This calculator has been designed to provide individualised dosing and monitoring guidance for patients prescribed enoxaparin at The Prince Charles Hospital based upon local guidelines.</Typography>
            <Typography variant="body1" style={{marginBottom:10}}>When to use this calculator?</Typography>
            <Typography variant="body2" style={{marginBottom:20}}>Use this calculator for any patient prescribed subcutaneous enoxaparin. The calculator will provide patient individualised dosing and monitoring guidance based upon the calculated creatinine clearance (CrCl).</Typography>
            <Typography variant="body2" style={{marginBottom:10}}><strong>Disclaimer:</strong> This calculator has been designed to provide decision support for clinicians to support the safe prescribing and monitoring of enoxaparin.  The suggested guidelines should be considered in the context of the patient’s clinical condition, comorbidities and other medicines prescribed.  Consult a specialist for further advice.</Typography>
            <Typography variant="caption" display="block">
                The decision support included within this calculator is based upon TPCH Safe use of enoxaparin procedure.  
                Additional information relating to enoxaparin is available within the Product Information and Statewide 
                Guidelines for Anticoagulation and Prophylaxis using Low Molecular Weight Heparin (LMWH) in adult patients.
            </Typography>
              
        </div>
    )
}

export default Welcome;